import { token, book_sub } from '@/api/index'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { setLocal, setSession, getLocal, getSession } from '@/libs/storage'
import Cookies from 'js-cookie'
const state = {
    token: getToken(),
    name: '',
    avatar: '',
    introduction: '',
    roles: [],
    email: '',
    book: '',
    cookieTip: getLocal('cookieTip') ? getLocal('cookieTip') : Cookies.get('cookieTip') || false,
}

const mutations = {
    SET_TOKEN: (state, token) => {
        state.token = token
    },
    SET_INTRODUCTION: (state, introduction) => {
        state.introduction = introduction
    },
    SET_NAME: (state, name) => {
        state.name = name
    },
    SET_AVATAR: (state, avatar) => {
        state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
        state.roles = roles
    },
    SET_Email: (state, email) => {
        state.email = email
    },
    SET_Book: (state, book) => {
        state.book = book
    },
    cookieTip(state, status) {
        state.cookieTip = true
        if (status === 'REFUSE') {
            // setSession('cookieTip', true)
            Cookies.set('cookieTip', true)
        }
        if (status === 'ACCEPT') {
            setLocal('cookieTip', true)
        }
    },
}

const actions = {
    // user login
    book_sub({ commit }, info) {
        return new Promise((resolve, reject) => {
            book_sub(info)
                .then(response => {
                    // console.log(info);
                    commit('SET_Book', info)
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    // get user info
    getInfo({ commit, state }) {
        return new Promise((resolve, reject) => {
            getInfo(state.token)
                .then(response => {
                    const { data } = response
                    const { name, avatar, email } = data
                    const roles = data.groups
                    // roles.forEach(item => {
                    //   console.log(item.url);
                    // })
                    // roles must be a non-empty array
                    // if (!roles || roles.length <= 0) {
                    //   reject('getInfo: roles must be a non-null array!')
                    // }
                    commit('SET_ROLES', roles)
                    commit('SET_NAME', name)
                    commit('SET_AVATAR', avatar)
                    commit('SET_Email', email)
                    // commit('SET_INTRODUCTION', introduction)
                    resolve(roles)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    // user logout退出
    logout({ commit, state, dispatch }) {
        return new Promise((resolve, reject) => {
            logout(state.token)
                .then(() => {
                    commit('SET_TOKEN', '')
                    commit('SET_ROLES', [])
                    removeToken()
                    resetRouter()
                    // reset visited views and cached views
                    // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
                    dispatch('tagsView/delAllViews', null, { root: true })
                    resolve()
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    // remove token
    resetToken({ commit }) {
        return new Promise(resolve => {
            commit('SET_TOKEN', '')
            commit('SET_ROLES', [])
            removeToken()
            resolve()
        })
    },

    // dynamically modify permissions 动态修改权限
    async changeRoles({ commit, dispatch }, role) {
        commit('SET_TOKEN', 123123)
        setToken(123123)
        const { roles } = await dispatch('getInfo')

        resetRouter()

        // generate accessible routes map based on roles 基于角色生成可访问的路线图
        const accessRoutes = await dispatch('permission/generateRoutes', roles, {
            root: true,
        })
        // dynamically add accessible routes
        router.addRoutes(accessRoutes)

        // reset visited views and cached views 重置已访问视图和缓存视图
        dispatch('tagsView/delAllViews', null, {
            root: true,
        })
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
}
